






































































import Vue from 'vue'
import api from '@/api'
import { USER_ROLES } from '@/constants'

export default Vue.extend({
  data() {
    return {
      users: [] as any[],
      activeUser: null as any,
      deletingUser: false,
      confirmUserDeletionActive: false,
      columns: [
        { label: 'Nom', field: 'firstname', searchable: true },
        { label: 'Prénom', field: 'lastname', searchable: true },
        { label: 'Email', field: 'email', searchable: true },
        { label: 'Téléphone', field: 'phone', searchable: true },
        { label: 'Rôle', field: 'roleName' },
        { label: 'Statut', field: 'active' },
        { label: 'Actions', field: '_actions', align: 'right' }
      ]
    }
  },

  created() {
    this.fetchUsers()
  },

  watch: {
    $route() {
      this.fetchUsers()
    }
  },

  methods: {
    async fetchUsers() {
      try {
        const { data } = await api.get('/users')
        this.users = (data || []).map((u: any) => ({
          ...u,
          fullname: `${u.lastname} ${u.firstname}`,
          roleName: USER_ROLES[u.role] || u.role
        }))
      } catch (err) {
        console.error(err) // eslint-disable-line
      }
    },

    onEdit(id: string) {
      this.$router.push({ name: 'users.edit', params: { userId: id } })
    },

    onDeleteUserClick(user: any) {
      this.confirmUserDeletionActive = true
      this.activeUser = user
    },

    async onConfirmUserDeletion() {
      this.deletingUser = true
      try {
        const { data, status } = await api.delete(`/users/${this.activeUser.id}`)
        this.deletingUser = false
        this.confirmUserDeletionActive = false
        if (status === 200) {
          const { action, user } = data
          switch (action) {
            case 'delete':
              this.users = this.users.filter((u: any) => u.id !== user.id)
              this.$notify.success("L'utilisateur a été supprimé avec succès")
              break
            case 'deactivate': {
              const idx = this.users.findIndex((u: any) => u.id === user.id)
              if (idx !== -1) {
                this.$set(this.users, idx, {
                  ...this.users[idx],
                  ...user,
                  fullname: `${user.lastname} ${user.firstname}`,
                  roleName: USER_ROLES[user.role] || user.role
                })
              }
              this.$notify.success("L'utilisateur a été désactivé avec succès")
              break
            }
          }
        }
        this.activeUser = null
      } catch (err) {
        this.deletingUser = false
        this.confirmUserDeletionActive = false
        console.error(err) // eslint-disable-line

        const message =
          (err as any).response?.data?.message ||
          "La désactivation de l'utilisateur a échoué"
        this.$notify.error(message)
      }
    },

    async onReactivateUserClick(user: any) {
      try {
        const { data, status } = await api.put(`/users/${user.id}/reactivate`)
        if (status === 200) {
          const { user: updatedUser } = data
          const idx = this.users.findIndex((u: any) => u.id === updatedUser.id)
          if (idx !== -1) {
            this.$set(this.users, idx, {
              ...this.users[idx],
              ...updatedUser,
              fullname: `${updatedUser.lastname} ${updatedUser.firstname}`,
              roleName: USER_ROLES[updatedUser.role] || updatedUser.role
            })
          }
          this.$notify.success("L'utilisateur a été réactivé avec succès")
        }
      } catch (err) {
        console.error(err) 
        this.$notify.error("La réactivation de l'utilisateur a échoué")
      }
    }
  }
})
